import {
  ContentAccessUser,
  ContentWorkflow,
  UserProfile,
} from '@amzn/awscat-pattern-library-service-model';
import React from 'react';
import { displayByline } from '../../../api/UtilsApi';

interface Props {
  owner: UserProfile;
  coAuthors?: ContentAccessUser[];
  workflow?: ContentWorkflow;
}

const Byline = (props: Props) => {
  const { coAuthors, owner, workflow } = props;
  if (!owner && !workflow) {
    return null;
  }

  const authorInfo = displayByline(owner, coAuthors, workflow);

  return authorInfo ? <span>Created by {authorInfo}</span> : null;
};

export default Byline;
